import EnhancedUpload from './components/BaseUpload';
export default EnhancedUpload;
//# sourceMappingURL=index.js.map
